export default {
  track: data => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  },
}
